import useDatadogRum from './useDatadogRum';
export * from './useDatadogRum';
export default useDatadogRum;
